export default __webpack_public_path__ + "static/media/notification.ce6f67b9.wav";